import { mainConstants } from '../_constants';

export const toggleScreenSize = () => ({
  type: mainConstants.TOGGLE_SCREEN_SIZE
});

export const toggleSideBar = () => ({
  type: mainConstants.TOGGLE_SIDE_BAR
});

export const toggleActivePage = (currentPage) => ({
  type: mainConstants.TOGGLE_ACTIVE_PAGE,
  payload: currentPage
});

export const insertRoutes = (routes) => ({
  type: mainConstants.INSERT_ROUTES,
  payload: routes
});

export const enablePaging = () => ({
  type: mainConstants.ENABLE_PAGING
});

export const disablePaging = () => ({
  type: mainConstants.DISABLE_PAGING
});

export const insertPages = (pages) => ({
  type: mainConstants.INSERT_PAGES,
  payload: pages
});

export const updateErrorModal = (data) => ({
  type: mainConstants.UPDATE_ERROR_MODAL,
  payload: data
});

export const clearErrorModal = () => ({
  type: mainConstants.CLEAR_ERROR_MODAL
});
